// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c3c807a0","419":"c020c257","563":"4d555e47","787":"c173e44a","942":"ec51c568"}[chunkId] + ".chunk.js";
};